import { render, staticRenderFns } from "./TransformationIcon.vue?vue&type=template&id=4583fb35&"
import script from "./TransformationIcon.vue?vue&type=script&lang=js&"
export * from "./TransformationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports